import {popupUtil} from './popup';
import Login from '@/modules/register-landing/popups/Login.svelte';
import Register from '@/modules/register-landing/popups/Register.svelte';
import ResetPassword from '@/modules/register-landing/popups/ResetPassword.svelte';
import EmailVerification from '@/modules/register-landing/popups/EmailVerification.svelte';
import CommonEmailVerification from '@/modules/account/security/components/EmailVerification.svelte';
import GoogleVerification from '@/modules/register-landing/popups/GoogleVerification.svelte';
import InputNewPassword from '@/modules/register-landing/popups/InputNewPassword.svelte';
import SafetyVerificationPage from '@/modules/safety-verification/SafetyVerification.svelte';
import SafetyEmailVerificationPage from '@/modules/verification/Verification.svelte';
import GoogleVerificationPage from '@/modules/google-verification/GoogleVerification.svelte';
import BindGoogleVerificationPage from '@/modules/bind-google-account/BindGoogleAccount.svelte';
import RegisterTips from '@/modules/register/popups/RegisterTips.svelte';
import NewDeviceCodeDrawer from '@/modules/login/popups/NewDeviceCodeDrawer.svelte';

export const drawerUtil = {
  launchLogin(LG, target, email, newRegisterPage) {
    popupUtil.create(Login, {LG, target, email, newRegisterPage});
  },
  launchRegister(LG, target, record, email) {
    popupUtil.create(Register, {LG, target, record, email});
  },
  launchResetPassword(LG, target) {
    popupUtil.create(ResetPassword, {LG, target});
  },
  launchEmailVerification(LG, emailData) {
    popupUtil.create(EmailVerification, {LG, emailData});
  },
  launchCommonEmailVerification(LG, emailData) {
    popupUtil.create(CommonEmailVerification, {LG, emailData});
  },
  launchGoogleVerification(LG, googleData) {
    popupUtil.create(GoogleVerification, {LG, googleData});
  },
  launchInputNewPassword(LG, newPasswordData) {
    popupUtil.create(InputNewPassword, {LG, newPasswordData});
  },
  launchSafetyVerificationPage(LG, verificationData) {
    popupUtil.create(SafetyVerificationPage, {LG, verificationData});
  },
  launchSafetyEmailVerificationPage(LG, verificationData) {
    popupUtil.create(SafetyEmailVerificationPage, {LG, verificationData});
  },
  launchGoogleVerificationPage(LG, verificationData) {
    popupUtil.create(GoogleVerificationPage, {LG, verificationData});
  },
  launchBindGoogleVerificationPage(LG, verificationData, oauthData) {
    popupUtil.create(BindGoogleVerificationPage, {LG, verificationData, oauthData});
  },
  launchRegisterTips(LG, entrance) {
    popupUtil.create(RegisterTips, {LG, entrance});
  },
  launchNewDeviceVerification(verificationData) {
    popupUtil.create(NewDeviceCodeDrawer, verificationData);
  },
};
